import { Card, CardContent } from '@mui/material'
import { useEffect } from 'react'
import { FaRegComments } from 'react-icons/fa6'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import IconBack from '../components/IconBack'
import { useAuth } from '../context/AuthContext'

const Mensagem = () => {
  const history = useHistory()
  const { validateAccess } = useAuth()

  useEffect(() => {
    validateAccess()
    const userFormat = {
      ...JSON.parse(localStorage.getItem('@sisarma-socio-notifications')),
      mensagem: '8', //* Change the number when a new message is added (CardsInitial too)
    }
    localStorage.setItem(
      '@sisarma-socio-notifications',
      JSON.stringify(userFormat)
    )

    document.title = 'SisarmaApp | Mensagem'
  }, [validateAccess])

  return (
    <section>
      <Card className="relative">
        <div
          className="absolute top-6 right-5 text-xl cursor-pointer"
          onClick={() => history.push('/')}
        >
          <IconBack />
        </div>
        <div className="p-5">
          <div className="flex items-center gap-1">
            <FaRegComments />
            <h1 className="text-lg font-semibold">Mensagem</h1>
          </div>
        </div>
      </Card>
      <Card className="mt-2">
        <CardContent className="space-y-3">
          <div className="sm:p-5 space-y-3">
            <strong>Prezados Atiradores!🎯</strong>
            <p>
              Solicitamos que verifiquem a validade de suas Guias de Tráfego
              (GT) antes de se deslocarem ao Clube Armeria. Para sua segurança
              jurídica e cumprimento das normas, certifique-se de que o
              documento esteja devidamente validado.
            </p>
            <p>
              Caso sua guia esteja vencida ou próxima do vencimento, realize a
              atualização imediata para evitar transtornos durante o transporte.
            </p>
            <p>
              Atenciosamente,
              <br />
              Clube Armeria
            </p>
          </div>
          {/* <img
            src="/comunicado.jpeg"
            alt="Comunicado"
            className="w-full sm:max-w-lg mx-auto"
          /> */}
        </CardContent>
      </Card>
    </section>
  )
}

export default Mensagem
